exports.reset = function (css) {
  var style = document.createElement('style');

  style.type = 'text/css';

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }

  (document.head || document.getElementsByTagName('head')[0]).appendChild(style);
};


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/libs/utils/style.js
// module id = 327
// module chunks = 0